// Components
import TurnsModal from './TurnsModal'
import AddUserDialog from './AddUserDialog'
import ConfirmScaleModal from './ConfirmScaleModal'
import ConfirmDialog from '@/modals/ConfirmDialog'
import SosButton from '@/components/SosButton'
import SosSelect from '@/components/SosSelect'
import SosEditShiftCard from './SosEditShiftCard'

import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

import { valueToDB, valueToTime } from '@/functions'
import { formatFloatToScaleDuration, durationToMinutes, formatDbTime } from '@/mixins/utils'
import scaleMixin from '@/mixins/scale.mixin.js'
import confirmDialogMixin from '@/mixins/cd.mixin.js'

import userProfileBroken from '@/assets/images/user-profile-broken.png'

import { mapState } from 'vuex'

import { apiServerTimestamp } from '@/services/index'
import { isValidDuty, createDutyObject, apiGetGroupDutyChatMessages, apiGetGroupShifts } from '@/services/duties'
import { apiGetCurrentUser, apiGenerateEntityID, fbFullUpdate, apiUpdateScaleName, apiGetGroupNewWeekChatMessages, createShift } from '@/services/firebase'

import moment from 'moment'
import 'moment/locale/pt-br'
moment.locale('pt-BR')

//
// Função para calcular o horário de término de um plantão
//

const calculateEndDateAndTime = (startDate, startTime, duration, withZero = false) => {
  const [startHour, startMinute] = String(startTime).split(':').map(Number)
  const [year, month, day] = String(startDate).split('-').map(Number)
  const [durationHours, durationMinutes] = String(duration).split(':').map(Number)

  // Convertendo a duração total para minutos
  const totalMinutes = startHour * 60 + startMinute + durationHours * 60 + durationMinutes
  const endHour = Math.floor(totalMinutes / 60) % 24
  const endMinute = totalMinutes % 60

  // Adicionando a data inicial para criar um objeto de data e hora
  const endDate = new Date(year, month - 1, day, endHour, endMinute)

  // Verificando se a data final é no dia seguinte
  if (totalMinutes >= 24 * 60) {
    endDate.setDate(endDate.getDate() + 1)
  }

  // Formatando a data final para o formato YYYY-M-D (withZero === false) ou YYYY-MM-DD (withZero === true)
  const endDateYear = endDate.getFullYear()
  const endDateMonth = withZero ? String(endDate.getMonth() + 1).padStart(2, '0') : endDate.getMonth() + 1
  const endDateDay = withZero ? String(endDate.getDate()).padStart(2, '0') : endDate.getDate()
  const endDateHour = String(endDate.getHours()).padStart(2, '0')
  const endDateMinute = String(endDate.getMinutes()).padStart(2, '0')

  return `${endDateYear}-${endDateMonth}-${endDateDay} ${endDateHour}:${endDateMinute}`
}

//
// TESTAR PASSAGEM DE ANO
//

const checkConflict = (plantao1, plantao2, intervalo = false/* , nome = 'Function Unknown' */) => {
  //
  const shiftStartDateAndTime = (new Date(plantao1.startDate + 'T' + plantao1.startTime + ':00.000Z')).getTime()

  // console.log(`::: [${nome}] shiftStartDateAndTime:`, plantao1.startDate + ' ' + plantao1.startTime)

  //
  let shiftEndDateAndTime = calculateEndDateAndTime(plantao1.startDate, plantao1.startTime, plantao1.duration, true).split(' ')
  // console.log(`::: [${nome}] shiftEndDateAndTime:`, shiftEndDateAndTime[0] + ' ' + shiftEndDateAndTime[1])
  shiftEndDateAndTime = (new Date(shiftEndDateAndTime[0] + 'T' + shiftEndDateAndTime[1] + ':00.000Z')).getTime()

  //
  const turnStartDateAndTime = (new Date(plantao2.startDate + 'T' + plantao2.startTime + ':00.000Z')).getTime()
  // console.log(`::: [${nome}] turnStartDateAndTime:`, plantao2.startDate + ' ' + plantao2.startTime)
  let turnEndDateAndTime = calculateEndDateAndTime(plantao2.startDate, plantao2.startTime, plantao2.duration, true).split(' ')
  // console.log(`::: [${nome}] turnEndDateAndTime:`, turnEndDateAndTime[0] + ' ' + turnEndDateAndTime[1])
  turnEndDateAndTime = (new Date(turnEndDateAndTime[0] + 'T' + turnEndDateAndTime[1] + ':00.000Z')).getTime()

  // Converte o intervalo de horas para milissegundos
  const intervaloMilissegundos = !!intervalo === false ? 0 : intervalo /* * 60 */ * 60 * 1000

  // INÍCIO DO PLANTÃO EXISTENTE ESTÁ DENTRO DO TURNO?
  // FIM DO PLANTÃO EXISTENTE ESTÁ DENTRO DO TURNO?

  // console.log(`::: [${nome}] checkConflict:`, intervalo)

  return !!intervalo === false ? (
    ((shiftStartDateAndTime > turnStartDateAndTime) && (shiftStartDateAndTime < turnEndDateAndTime)) ||
    ((shiftEndDateAndTime > turnStartDateAndTime) && (shiftEndDateAndTime < turnEndDateAndTime))
  ) : (
    ((shiftStartDateAndTime >= turnStartDateAndTime) && (shiftStartDateAndTime <= turnEndDateAndTime + intervaloMilissegundos)) ||
    ((shiftEndDateAndTime >= turnStartDateAndTime) && (shiftEndDateAndTime <= turnEndDateAndTime + intervaloMilissegundos))
  )
}

//
//
//

export default {
  name: 'EditScale',

  components: {
    TurnsModal,
    AddUserDialog,
    ConfirmScaleModal,
    ConfirmDialog,
    'sos-select': SosSelect,
    'date-picker': DatePicker,
    'sos-button': SosButton,
    'sos-edit-shift-card': SosEditShiftCard,
  },

  mixins: [
    scaleMixin,
    confirmDialogMixin,
  ],

  data () {
    return {
      showGoToTopButton: false,

      showScaleCurrentWeekHeader: false,

      //
      // JOURNEY
      //

      jornada: 'Manual',

      journeyWorkingDays: '',
      journeyDaysOff: '',

      workingJourneys: [
        { key: 'jornada_manual', text: '<span class="journeyOption">Manual<br /><span class="journeyOptionObservation">Você escolhe o dia e turno</span></span>', value: 'Manual' },
        { key: 'jornada_semanal', text: '<span class="journeyOption">Semanal<br /><span class="journeyOptionObservation">Um plantão a cada 7 dias</span></span>', value: 'Semanal' },
        { key: 'jornada_12x36', text: '<span class="journeyOption">12x36<br /><span class="journeyOptionObservation">1 dia de trabalho e 1 de descanso</span></span>', value: '12x36' },
        { key: 'jornada_12x48', text: '<span class="journeyOption">24x48<br /><span class="journeyOptionObservation">1 dia de trabalho e 2 de descanso</span></span>', value: '12x48' },
        { key: 'jornada_12x72', text: '<span class="journeyOption">36x72<br /><span class="journeyOptionObservation">1 dia de trabalho e 3 de descanso</span></span>', value: '12x72' },
        { key: 'jornada_5x2', text: '<span class="journeyOption">5x2<br /><span class="journeyOptionObservation">5 dias de trabalho e 2 de descanso</span></span>', value: '5x2' },
        { key: 'jornada_6x1', text: '<span class="journeyOption">6x1<br /><span class="journeyOptionObservation">6 dias de trabalho e 1 de descanso</span></span>', value: '6x1' },
        { key: 'jornada_personalizada', text: '<span class="journeyOption">Personalizada<br /><span class="journeyOptionObservation">Você escolhe intervalo e sequência</span></span>', value: 'Personalizado' },
      ],

      //
      //
      //

      selectedTurn: null,
      selectedTurnData: null,
      selectedDate: null,
      selectedWeek: null,

      loadingMessage: 'Carregando...',
    }
  },

  computed: {
    ...mapState({
      group: state => state.app.group,
      groupUsers: state => state.app.groupUsers,
      listeners: state => state.app.listeners,
    }),

    nomeDoGrupo () {
      return !!this.group && !!this.group.nome ? this.group.nome : ''
    },
  },

  watch: {
    weeks: {
      handler (newVal, oldVal) {
        this.$store.commit('SET_WEEKS', this.weeks)
      },
    },

    //
    // START ON MONDAY será atualizado quando A ESCALA É CARREGADA (confirmar IMMEDIATE?)
    //

    startOnMonday: {
      handler (newVal, oldVal) {
        if (oldVal === 'waiting' && newVal !== 'waiting') {
          // [24/01/25] console.log('::: EditScale > startOnMonday:', newVal)

          //
          // CACHED FILTERS
          //

          let parsedFilters = null

          const filters = localStorage.getItem(`@sosplantao_editscale_${this.$route.params.scaleID}`)

          if (!!filters === true) {
            try {
              parsedFilters = JSON.parse(filters)
            } catch (e) {
              localStorage.removeItem(`@sosplantao_editscale_${this.$route.params.scaleID}`)
            }
          }

          if (!!parsedFilters === true) this.scaleZoom = parsedFilters.zoom

          // CONSTRÓI O CALENDÁRIO APÓS RECONHECER QUAL O PRIMEIRO DIA DA SEMANA ESCOLHIDO PELOS GESTORES
          this.setYearMonthSetup(!!parsedFilters === true ? { month: parsedFilters.month, year: parsedFilters.year } : false)

          // GO TO WEEK
          // console.log('::: EditScale => GO TO WEEK => firstDayOfCurrentWeek:', this.firstDayOfCurrentWeek)

          /* this.$nextTick(() => {
            if (!!this.firstDayOfCurrentWeek === true) {
              this.goToCurrentWeek(`${this.firstDayOfCurrentWeek}`)
            }
          }) */
        }
      },
    },
  },

  mounted () {
    const { groupID, scaleID } = this.$route.params

    // LOAD SCALE
    this.loadScale(groupID, scaleID)

    // GO TO WEEK

    // APÓS ATUALIZAR A PÁGINA (Exemplo: F5) OS DETALHES DO GRUPO (E USUÁRIOS) SERÃO CARREGADOS.
    // ELES SÃO USADOS NA TELA AddUserDialog
    this.$store.dispatch('loadGroupPage', groupID)

    this.localGroupID = groupID
    this.localScaleID = scaleID

    window.addEventListener('scroll', this.handleScroll) // SCROLL
    window.addEventListener('keydown', this.handleKeydown) // UNDO

    // [24/01/25] console.log('::: EditScale => mounted:', groupID, scaleID)
  },

  beforeDestroy () {
    // [24/01/25] console.log('::: EditScale => beforeDestroy')

    window.removeEventListener('scroll', this.handleScroll) // SCROLL
    window.removeEventListener('keydown', this.handleKeydown) // UNDO

    // APLICA JORNADA MANUAL
    this.$store.commit('SET_WORKINGDAY', 'Manual')

    // LIMPA O CTRL+Z (apenas visualmente, não no banco de dados)
    this.$store.commit('CLEAR_EDIT_SCALE_CTRL_Z')
  },

  destroyed () {
    // [24/01/25] console.log('::: EditScale => destroyed')

    this.unloadScale()
  },

  methods: {
    setYearMonthWeek (date, type)
    {
      if (date !== null)
      {
        const monthYear = date.split('/')

        const month = monthYear[0]
        const year = Number(monthYear[1])

        // [24/01/25] console.log('::: EDIT SCALE:', date, type)

        this.generateWeeksInMonth(year, month, 'weeks')

        //
        // CACHE
        //

        localStorage.setItem(`@sosplantao_editscale_${this.$route.params.scaleID}`, JSON.stringify({ month, year, zoom: this.scaleZoom }))
      }
    },

    setZoom (zoom) {
      this.scaleZoom = zoom

      //
      // CACHE
      //

      localStorage.setItem(`@sosplantao_editscale_${this.$route.params.scaleID}`, JSON.stringify({ month: this.actualMonth, year: this.actualYear, zoom }))
    },

    onJourneyDaysOffChange (inputText) {
      let journeyDaysOff = inputText.trim().replace(/[^\d]+/g, '').replace(/^0+/, '')
      journeyDaysOff = journeyDaysOff.length > 0 ? (Number(journeyDaysOff) > 31 ? '' : journeyDaysOff) : ''

      this.journeyDaysOff = journeyDaysOff

      this.$store.commit('SET_DAYSOFFAMOUNT', journeyDaysOff)
    },

    onJourneyWorkingDaysChange (inputText) {
      let journeyWorkingDays = inputText.trim().replace(/[^\d]+/g, '').replace(/^0+/, '')
      journeyWorkingDays = journeyWorkingDays.length > 0 ? (Number(journeyWorkingDays) > 31 ? '' : journeyWorkingDays) : ''

      this.journeyWorkingDays = journeyWorkingDays

      this.$store.commit('SET_WORKINGDAYSAMOUNT', journeyWorkingDays)
    },

    resetJourney () {
      this.setJornada('Manual')
    },

    /**
     *
     * VERIFICA SE O PLANTÃO PODE SER COLOCADO NO TURNO
     * > SE SIM, ADICIONA NA ESCALA/PLANTÕES
     * > CASO CONTRÁRIO, MOSTRA UM ERRO/AVISO NA TELA
     *
     */

    async adicionarDisponivel (turnID, selectedDate, turn)
    {
      if (this.$store.state.app.EditScale.jornada === 'Personalizado' && (Number(this.$store.state.app.EditScale.journeyWorkingDays) <= 0 || Number(this.$store.state.app.EditScale.journeyWorkingDays) > 31 || Number(this.$store.state.app.EditScale.journeyDaysOff) <= 0 || Number(this.$store.state.app.EditScale.journeyDaysOff) > 31)) {
        return this.showMessage('Aviso!', 'Você não terminou de personalizar a jornada!<br/ ><br />Desfaça a personalização ou informe quantos dias seguidos você quer inserir plantões (número de 1 a 31) e quantos dias de descanso.<br /><br />Depois tente incluir um novo plantão.')
      }

      //
      //
      //

      const weeks = this.weeks.map(week => ({ ...week, isReleasedWeek: this.isWeekReleased(week) }))

      const fullUpdate = await createShift({
        user: { availableTurn: true }, // DISPONÍVEL
        userScaleHourlyRate: 0,
        jornada: this.$store.state.app.EditScale.jornada,
        journeyWorkingDays: this.$store.state.app.EditScale.journeyWorkingDays,
        journeyDaysOff: this.$store.state.app.EditScale.journeyDaysOff,
        weeks,
        turnID,
        turnoDados: turn,
        dataSemZero: selectedDate.day.format('YYYY-M-D'),
        groupID: this.$route.params.groupID,
        grupoNome: this.nomeDoGrupo,
        scaleID: this.$route.params.scaleID,
        scaleName: this.scaleName,
        scaleLocation: this.scaleLocation,
      })

      // [24/01/25] console.log('::: EditScale => adicionarDisponivel => fullUpdate:', fullUpdate.firebasePaths)
      // [24/01/25] console.log('::: EditScale => adicionarDisponivel => references:', fullUpdate.references)

      //
      //
      //

      this.loading = true
      const response = await fbFullUpdate(fullUpdate.firebasePaths)
      this.loading = false

      if (response.code === 0) {
        // [24/01/25] console.log('::: EditScale => UPDATE ERROR:', response)
      } else {
        // [24/01/25] console.log('::: EditScale => UPDATED')
        this.$store.commit('SET_EDIT_SCALE_CTRL_Z', { type: 'add', data: fullUpdate.firebasePaths })
      }
    },

    //
    //
    //

    /* https://stackoverflow.com/questions/60380315/stick-date-to-the-top-until-a-new-dates-appears-during-scroll-like-in-whatsapp */

    handleScroll (event) {
      //
      //

      if (window.scrollY >= 300 && !this.showGoToTopButton) {
        // [24/01/25] console.log('SHOW GO TO TOP BUTTON')
        this.showGoToTopButton = true
      }

      if (window.scrollY < 300 && this.showGoToTopButton) {
        // [24/01/25] console.log('REMOVE GO TO TOP BUTTON')
        this.showGoToTopButton = false
      }

      //
      //
      //

      if (document.body.clientWidth <= 699 || this.scaleZoom !== '1')
      {
        if (this.showScaleCurrentWeekHeader === true) {
          this.showScaleCurrentWeekHeader = false

          // MOSTRAR
          const scaleBar = document.getElementById('scaleBar')
          if (scaleBar && scaleBar.classList) {
            scaleBar.classList.remove('scaleCalendarCurrentWeekWrapper--show')
          }
        }
      }
      else
      {
        const weekOne = document.getElementById('busstop_morning_0')
        const weekOneTop = weekOne ? weekOne.getBoundingClientRect().top : false

        const weekTwo = document.getElementById('busstop_morning_1')
        const weekTwoTop = weekTwo ? weekTwo.getBoundingClientRect().top : false

        const weekThree = document.getElementById('busstop_morning_2')
        const weekThreeTop = weekThree ? weekThree.getBoundingClientRect().top : false

        const weekFour = document.getElementById('busstop_morning_3')
        const weekFourTop = weekFour ? weekFour.getBoundingClientRect().top : false

        const weekFive = document.getElementById('busstop_morning_4')
        const weekFiveTop = weekFive ? weekFive.getBoundingClientRect().top : false

        const weekSix = document.getElementById('busstop_morning_5')
        const weekSixTop = weekSix ? weekSix.getBoundingClientRect().top : false

        const scrolledWeekOne = weekOneTop ? (weekOneTop <= 20 /* -60 */) : false // 170
        const scrolledWeekTwo = weekTwoTop ? (weekTwoTop <= 20 /* -60 */) : false // 170
        const scrolledWeekThree = weekThreeTop ? (weekThreeTop <= 20 /* -60 */) : false // 170
        const scrolledWeekFour = weekFourTop ? (weekFourTop <= 20 /* -60 */) : false // 170
        const scrolledWeekFive = weekFiveTop ? (weekFiveTop <= 20 /* -60 */) : false // 170
        const scrolledWeekSix = weekSixTop ? (weekSixTop <= 20 /* -60 */) : false // 170

        // console.log(`Week 1[${weekOneTop}]: ${scrolledWeekOne} / Week 2[${weekTwoTop}]: ${scrolledWeekTwo} / Week 3[${weekThreeTop}]: ${scrolledWeekThree} / Week 4[${weekFourTop}]: ${scrolledWeekFour} / Week 5[${weekFiveTop}]: ${scrolledWeekFive} / Week 6[${weekSixTop}]: ${scrolledWeekSix}`)

        //
        // EXIBIR BARRA

        const scaleBar = document.getElementById('scaleBar')

        if (scrolledWeekOne === true /* top >= 460 */ && this.showScaleCurrentWeekHeader === false) {
          this.showScaleCurrentWeekHeader = true

          if (scaleBar && scaleBar.classList) {
            scaleBar.classList.add('scaleCalendarCurrentWeekWrapper--show')
          }
        }

        if (scrolledWeekOne === false /* top < 460 */ && this.showScaleCurrentWeekHeader === true) {
          this.showScaleCurrentWeekHeader = false

          if (scaleBar && scaleBar.classList) {
            scaleBar.classList.remove('scaleCalendarCurrentWeekWrapper--show')
          }
        }

        //
        // IDENTIFICAR SEMANA ATUAL

        let currentWeekID = false

        if (scrolledWeekOne === true && scrolledWeekTwo === false) {
          currentWeekID = 0
        } else if (scrolledWeekTwo === true && scrolledWeekThree === false) {
          currentWeekID = 1
        } else if (scrolledWeekThree === true && scrolledWeekFour === false) {
          currentWeekID = 2
        } else if (scrolledWeekFour === true && scrolledWeekFive === false) {
          currentWeekID = 3
        } else if (scrolledWeekFive === true && scrolledWeekSix === false) {
          currentWeekID = 4
        } else if (scrolledWeekSix) {
          currentWeekID = 5
        }

        //
        // APLICAR OS DIAS (DA SEMANA ATUAL) DENTRO DA BARRA

        if (currentWeekID !== false) {
          /* document.getElementById(`currentWeekDay_${currentWeekID}_0`).innerHTML = */

          const $currentWeekDayOne = document.getElementById('currentWeekDayOne')
          if ($currentWeekDayOne) {
            $currentWeekDayOne.innerHTML = this.weeks[currentWeekID].value[0].day.format('ddd - DD/MM')
          }
          const $currentWeekDayTwo = document.getElementById('currentWeekDayTwo')
          if ($currentWeekDayTwo) {
            $currentWeekDayTwo.innerHTML = this.weeks[currentWeekID].value[1].day.format('ddd - DD/MM')
          }
          const $currentWeekDayThree = document.getElementById('currentWeekDayThree')
          if ($currentWeekDayThree) {
            $currentWeekDayThree.innerHTML = this.weeks[currentWeekID].value[2].day.format('ddd - DD/MM')
          }
          const $currentWeekDayFour = document.getElementById('currentWeekDayFour')
          if ($currentWeekDayFour) {
            $currentWeekDayFour.innerHTML = this.weeks[currentWeekID].value[3].day.format('ddd - DD/MM')
          }
          const $currentWeekDayFive = document.getElementById('currentWeekDayFive')
          if ($currentWeekDayFive) {
            $currentWeekDayFive.innerHTML = this.weeks[currentWeekID].value[4].day.format('ddd - DD/MM')
          }
          const $currentWeekDaySix = document.getElementById('currentWeekDaySix')
          if ($currentWeekDaySix) {
            $currentWeekDaySix.innerHTML = this.weeks[currentWeekID].value[5].day.format('ddd - DD/MM')
          }
          const $currentWeekDaySeven = document.getElementById('currentWeekDaySeven')
          if ($currentWeekDaySeven) {
            $currentWeekDaySeven.innerHTML = this.weeks[currentWeekID].value[6].day.format('ddd - DD/MM')
          }
        }
      }
    },

    toTop () {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },

    //
    //
    //

    openTurnsModal: function ()
    {
      this.$refs.turnsModal.open({
        mes: this.actualMonth,
        ano: this.actualYear,
        groupID: this.localGroupID,
        scaleID: this.localScaleID,
        turns: this.scaleTurns,
      })
    },

    goToViewScale () {
      this.$router.push(`/admin/grupos/${this.localGroupID}/escalas/${this.localScaleID}`)
    },

    goBackToGroupScales () {
      this.$router.push(`/admin/grupos/${this.localGroupID}/escalas`)
    },

    openConfirmScaleModal (weekID) {
      // possibilidade de verificar aqui se há plantões na semana antes de permitir modal
      this.selectedWeek = this.weeks[weekID]
      this.$refs.csModal.open()
    },

    //
    // UNDO
    //

    handleKeydown (event) {
      if (event.keyCode === 90 && event.ctrlKey && this.$store.state.app.EditScale.ctrl_z.data.length > 0) {
        this.undo()
      }
    },

    async undo () {
      const fullUpdate = {}

      const ctrl_z_Data = this.$store.state.app.EditScale.ctrl_z.data;

      ctrl_z_Data.forEach((reference, index) => {
        if (index === ctrl_z_Data.length - 1) {
          Object.keys(reference.data).forEach(path => {
            fullUpdate[path] = null
          })
        }
      })

      // [24/01/25] console.log('::: undo:', fullUpdate)

      const response = await fbFullUpdate(fullUpdate)

      if (response.code === 0) {
        // [24/01/25] console.log('::: Houve um erro ao desfazer os plantões:', response)
      } else {
        // [24/01/25] console.log('::: Os plantões foram desfeitos')

        this.$store.commit('CLEAR_EDIT_SCALE_CTRL_Z')
      }
    },

    openClearWeekConfirmModal (week) {
      if (!this.weekHasScale(week)) {
        // [24/01/25] console.log('openClearWeekConfirmModal: A SEMANA NÃO TEM ESCALA')
        return false
      }

      // [24/01/25] console.log('openClearWeekConfirmModal:', week)

      const weekStart = week.value[0].dayFmt
      const weekEnd = week.value[6].dayFmt

      // (não os plantões)

      this.showDialog('Atenção!', `A escala que vai do dia ${weekStart} até ${weekEnd} será apagada. <b>Deseja continuar?</b>`, 'clean-week', week)
    },

    openCloneWeekConfirmModal (week) {
      if (!this.weekHasScale(week)) {
        // [24/01/25] console.log('openCloneWeekConfirmModal: A SEMANA NÃO TEM ESCALA')
        return false
      }

      // [24/01/25] console.log('openCloneWeekConfirmModal:', week)

      const weekStart = week.value[0].dayFmt
      const weekEnd = week.value[6].dayFmt

      // (não os plantões)

      const nextFreeWeek = this.getNextFreeWeek(week)
      // [24/01/25] console.log('::: nextFreeWeek:', nextFreeWeek)

      this.showDialog('Atenção!', `A escala que começa no dia ${weekStart} e termina no dia ${weekEnd} será copiada para a próxima semana livre:<br /><br />Do dia ${nextFreeWeek['0']} até ${nextFreeWeek['6']}<br /><br />Os plantões não serão copiados.<br /><b>Deseja continuar?</b>`, 'clone-week', week)
    },

    openEditWeekConfirmModal (week) {
      // [24/01/25] console.log('openEditWeekConfirmModal:', week)

      const weekStart = week.value[0].dayFmt
      const weekEnd = week.value[6].dayFmt

      this.showDialog('Atenção!', `Os plantões dessa semana (Do dia ${weekStart} até ${weekEnd}) serão apagados e os plantonistas vão perder os seus plantões. <b>Deseja continuar?</b>`, 'edit-week', week)
    },

    async cdAction (cdResponse) {
      // [24/01/25] console.log('cdAction:', cdResponse)

      if (cdResponse === false) return

      const $this = this

      var authUser = apiGetCurrentUser()
      var authUserID = authUser.uid

      /**
       *
       * Limpar semana
       *
       */

      if (cdResponse.cdType === 'clean-week') {
        const weekData = cdResponse.cdData

        const update = {}
        const pathsToRemove = []

        weekData.value.map(date => {
          var weekDay = date.dayFmtWzero

          if ($this.scaleTurns.length > 0) {
            $this.scaleTurns.forEach(turn => {
              if (turn.plantoes && turn.plantoes[weekDay]) {
                const path = `escalas/${$this.localGroupID}/${$this.localScaleID}/turnos/${turn.turnID}/plantoes/${weekDay}`
                update[path] = null
                pathsToRemove.push(path)
              }
            })
          }
        })

        // [24/01/25] console.log('::: CLEAN-WEEK:', update, pathsToRemove)

        if (pathsToRemove.length === 0) {
          this.showDialog('Atenção!', '<div style="text-align: center">Não foi possível limpar a semana, pois ela já está vazia.</div>', 'response', false, true, 'center')
        } else {
          const response = await fbFullUpdate(update)

          $this.$store.commit('SET_EDIT_SCALE_CTRL_Z', {
            type: 'removemany',
            data: pathsToRemove,
          })

          this.showDialog(response.code === 0 ? 'Atenção!' : 'Sistema', '<div style="text-align: center">' + (response.code === 0 ? 'Não foi possível limpar a semana. Por favor, tente novamente ou fale com nosso suporte.' : 'A semana foi limpa com sucesso.') + '</div>', 'response', false, true, 'center')
        }
      }

      /**
       *
       * Clonar escala (para a próxima semana)
       *
       */

      if (cdResponse.cdType === 'clone-week') {
        const weekData = cdResponse.cdData

        // const fullUpdate = this.buildDuplicatedWeek(weekData, 1)
        let fullUpdate = {}
        let code = 0
        let response

        /* // */
        let numberWeeksAhead = 0

        do {
          // Duplicar o setup da semana atual para a próxima, se houver dias disponíveis
          numberWeeksAhead++

          const obj = this.buildDuplicatedWeek(weekData, numberWeeksAhead)
          code = obj.code
          response = obj.response

          if (code === 1) {
            fullUpdate = response
          }
        } while (Object.keys(fullUpdate).length === 0)
        /* // */

        // fullUpdate = this.buildDuplicatedWeek(weekData.week, weekData.numberWeeksAhead)

        const updatesCount = code === 1 ? Object.keys(fullUpdate).length : 0

        // weekData.firstDayOfWeek

        if (code === 0) {
          // [24/01/25] console.log('::: CLONAR SEMANA [ERRO]:', weekData, fullUpdate, updatesCount)

          if (response === 'conflict') {
            this.showDialog('Atenção!', 'Desculpe, não foi possível copiar a escala, pois a próxima semana não está limpa.', 'response', false, true)
          } else if (response === 'empty') {
            this.showDialog('Atenção!', 'Não foi possível copiar a semana, pois ela está vazia.', 'response', false, true)
          }
        } else {
          // [24/01/25] console.log('::: CLONAR SEMANA:', weekData, fullUpdate, updatesCount)

          const response = await fbFullUpdate(fullUpdate)

          this.showDialog(response.code === 0 ? 'Atenção!' : 'Sistema', '<div style="text-align: center">' + (response.code === 0 ? 'Não foi possível duplicar a semana. Por favor, tente novamente ou fale com nosso suporte.' : 'A semana foi duplicada com sucesso') + '</div>', 'response', false, true, 'center')
        }
      }

      /**
       *
       * Apagar usuário de uma semana já disparada
       *
       */

      if (cdResponse.cdType === 'remove-confirmed-user')
      {
        const { turnID, day, turnUserID, turnUserIndex, week } = cdResponse.cdData

        // [24/01/25] console.log('::: RETIRAR USUÁRIO DO DIA')

        const date = day.dayFmtWzero

        //
        // BASE

        const path = 'escalas/' + this.localGroupID + '/' + this.localScaleID + '/turnos/' + turnID + '/plantoes/' + date

        //
        //

        const turn = this.scaleTurns.length > 0 ? this.scaleTurns.find(scaleTurn => scaleTurn.turnID === turnID) : false

        // [24/01/25] console.log('::: remove-confirmed-user:', turn, turnUserIndex)

        const turnDutyDate = !!turn === true && !!turn.plantoes[date] === true ? turn.plantoes[date] : false
        // const isTurnDutyAvailable = turnDutyDate && !!turnDutyDate.users === true && !!turnDutyDate.users[turnUserID] === true && !!turnDutyDate.users[turnUserID].availableTurn === true
        const plantoesIDs = turnDutyDate && !!turnDutyDate.plantoesIDs === true ? Object.keys(turnDutyDate.plantoesIDs) : false
        const turnDutyID = plantoesIDs && plantoesIDs[turnUserIndex] ? plantoesIDs[turnUserIndex] : false

        //
        //

        if (turnDutyID !== false) {
          let fullUpdate = {}

          // fullUpdate[path + '/confirmedDutys'] = true

          // APAGA O PLANTÃO
          fullUpdate['plantoes/' + turnDutyID] = null

          // APAGA O LOG DO PLANTÃO
          fullUpdate['logs/plantoes/' + turnDutyID] = null

          /*
          // APAGA O PLANTÃO DO TURNO (EDITOR DE ESCALA)
          fullUpdate[path + '/plantoesIDs/' + turnDutyID] = null
          // vue.runtime.esm.js?2b0e:619 [Vue warn]: Error in v-on handler (Promise/async): "Error: Reference.update failed: First argument contains a path /escalas/-Mui-rUCEzvwjGL-1wbo/-MuiDPLk8vpuGztHGUEU/turnos/-MuiDVQUTEHLREwp1Zr9/plantoes/2021-12-29/plantoesIDs that is ancestor of another path /escalas/-Mui-rUCEzvwjGL-1wbo/-MuiDPLk8vpuGztHGUEU/turnos/-MuiDVQUTEHLREwp1Zr9/plantoes/2021-12-29/plantoesIDs/-MumhmTKGimgl3goJAz-"
          */

          // retirar usuário da escala
          fullUpdate[path + '/users/' + turnUserID] = null

          // APAGA O PLANTÃO DO GRUPO
          fullUpdate['grupos/' + this.localGroupID + '/plantoes/' + turnDutyID] = null

          // ATUALIZA O TIMESTAMP DO GRUPO PARA PROVOCAR UM RECARREGAMENTO DOS DADOS
          fullUpdate['grupos/' + this.localGroupID + '/data_atual'] = apiServerTimestamp()

          //
          // ---------------------------------------------------------------
          // APAGA MENSAGENS RELACIONADAS AO PLANTÃO
          // ---------------------------------------------------------------
          //

          // if (isTurnDutyAvailable) {

          let dutyMessages = await apiGetGroupDutyChatMessages(this.localGroupID, turnDutyID)
          dutyMessages = dutyMessages !== false ? Object.keys(dutyMessages) : []

          if (dutyMessages.length > 0) {
            dutyMessages.forEach(messageID => {
              fullUpdate['chats/' + this.localGroupID + '/chats/' + messageID] = null
            })
          }

          // ---------------------------------------------------------------
          //

          //
          // SE ESTIVER APAGANDO O ÚLTIMO PLANTÃO, LIBERA A SEMANA NOVAMENTE

          /* if (this.weekWasReleaseAndHasOneDuty(week)) {
            fullUpdate[path + '/plantoesIDs'] = null
            fullUpdate[path + '/confirmedDutys'] = null
          } */

          const openWeek = {}
          const weekSetup = week.value

          // Primeiro verifica se há dias disponíveis na semana
          let semanaDisparada = false
          let dutiesCount = 0

          if (this.scaleTurns.length > 0)
          {
            // Depois verifica se plantões já foram disparados na semana
            weekSetup.map((d) => {
              var weekDate = d.dayFmtWzero

              this.scaleTurns.map(turn => {
                if (turn.plantoes) {
                  if (turn.plantoes[weekDate] && turn.plantoes[weekDate].confirmedDutys === true) {
                    semanaDisparada = true
                    openWeek['escalas/' + $this.localGroupID + '/' + $this.localScaleID + '/turnos/' + turn.turnID + '/plantoes/' + weekDate + '/plantoesIDs'] = null
                    openWeek['escalas/' + $this.localGroupID + '/' + $this.localScaleID + '/turnos/' + turn.turnID + '/plantoes/' + weekDate + '/confirmedDutys'] = null
                  }

                  if (turn.plantoes[weekDate] && turn.plantoes[weekDate].users) {
                    const soma = Object.keys(turn.plantoes[weekDate].users).length
                    if (soma > 0) {
                      dutiesCount += soma
                    }
                  }
                };
              })
            })
          }

          if (semanaDisparada === true && dutiesCount === 1)
          {
            //
            // MARCA A MENSAGEM DE NOVA SEMANA (NO CHAT) PARA SER APAGADA
            //
            // *** JESUS ESTÁ VIVO ***
            //

            const newWeekChatMessages = await apiGetGroupNewWeekChatMessages($this.localGroupID, week.firstDayOfWeek)

            // console.log('apiGetGroupNewWeekChatMessages:', $this.localGroupID, week.firstDayOfWeek, newWeekChatMessages)

            if (newWeekChatMessages !== false) {
              Object.keys(newWeekChatMessages).map(messageKey => {
                fullUpdate['chats/' + $this.localGroupID + '/chats/' + messageKey] = null
              })
            }

            //
            // NOVA MENSAGEM (+ NOTIFICAÇÃO) PARA O GRUPO:
            // -> A SEMANA FOI APAGADA
            //

            const groupName = $this.group.nome || ''
            const scaleName = $this.scaleName || ''
            const weekStart = week.value[0].dayLabel
            const weekEnd = week.value[week.value.length - 1].dayLabel

            //
            // *** JESUS ESTÁ VIVO ***
            //

            const newChatKey = apiGenerateEntityID(`chats/${$this.localGroupID}/chats`)

            fullUpdate['chats/' + $this.localGroupID + '/chats/' + newChatKey] = {
              push: {
                type: 'edit-week',
              },
              uid: authUserID,
              tipo: 'message',
              // tipo: 'new-group',
              displayName: authUser.displayName,
              mensagem: `Os plantões da semana de ${weekStart} a ${weekEnd} foram apagados do grupo ${groupName} (Escala: ${scaleName}).`,
              timestamp: apiServerTimestamp(),
              data: apiServerTimestamp(),
            }

            //
            // APAGA O ÚLTIMO PLANTÃO E ABRE A SEMANA NOVAMENTE PARA EDIÇÃO

            fullUpdate = {
              ...fullUpdate,
              ...openWeek,
            }
          }
          else
          {
            // APAGA O PLANTÃO DO TURNO (EDITOR DE ESCALA)
            fullUpdate[path + '/plantoesIDs/' + turnDutyID] = null
            // vue.runtime.esm.js?2b0e:619 [Vue warn]: Error in v-on handler (Promise/async): "Error: Reference.update failed: First argument contains a path /escalas/-Mui-rUCEzvwjGL-1wbo/-MuiDPLk8vpuGztHGUEU/turnos/-MuiDVQUTEHLREwp1Zr9/plantoes/2021-12-29/plantoesIDs that is ancestor of another path /escalas/-Mui-rUCEzvwjGL-1wbo/-MuiDPLk8vpuGztHGUEU/turnos/-MuiDVQUTEHLREwp1Zr9/plantoes/2021-12-29/plantoesIDs/-MumhmTKGimgl3goJAz-"
          }

          // return semanaNaoFoiDisparada === false && dutiesCount === 1

          // [24/01/25] console.log('::: remove-confirmed-user:', semanaDisparada, dutiesCount, openWeek, plantoesIDs, fullUpdate)

          await fbFullUpdate(fullUpdate)
          // [24/01/25] const response = await fbFullUpdate(fullUpdate)

          /* if (response.code === 0) {
            // [24/01/25] console.log('::: [remove-confirmed-user] Houve um erro ao desfazer o plantão:', response)
          } else {
            // [24/01/25] console.log('::: [remove-confirmed-user] O plantão foi desfeito')
          } */
        }
      }

      /**
       *
       * Apagar usuário do dia e turno
       *
       */

      if (cdResponse.cdType === 'remove-user')
      {
        const { turnID, day, turnUserID } = cdResponse.cdData
        const { data } = this.$store.state.app.EditScale.ctrl_z

        const date = day.dayFmtWzero

        const path = 'escalas/' + this.localGroupID + '/' + this.localScaleID + '/turnos/' + turnID + '/plantoes/' + date + '/users/' + turnUserID

        /* VERIFICA SE O PLANTÃO FOI COLOCADO NO CTRL+Z PARA APAGAR ELE */
        const isMarkedToUndo = data.length > 0 ? data.findIndex(dutyPath => dutyPath === path) !== -1 : false

        const fullUpdate = {}
        fullUpdate[path] = null

        // console.log('::: removeUserFromTurn:', fullUpdate, path, data, isMarkedToUndo)

        // [24/01/25] console.log('::: removeUserFromTurn:', turnID, day, turnUserID)

        const response = await fbFullUpdate(fullUpdate)

        if (response.code === 0) {
          // [24/01/25] console.log('::: Houve um erro ao desfazer o plantão:', response)
        } else {
          // [24/01/25] console.log('::: O plantão foi desfeito:', path, data)

          if (isMarkedToUndo) {
            $this.$store.commit('SET_EDIT_SCALE_CTRL_Z', {
              type: 'remove',
              data: path,
            })

            // [24/01/25] console.log('::: O plantão foi retirado do CTRL+Z:', data)
          }
        }
      }

      /**
       *
       * DESFAZ OS PLANTÕES QUE FORAM DISPARADOS
       *
       */

      if (cdResponse.cdType === 'edit-week')
      {
        const week = cdResponse.cdData

        // setTimeout(async () => {

        var availableDays = week.value // $this.getAvailableDaysInWeek(week)

        const weekTurns = this.scaleTurns

        const turnDutiesBasePath = 'escalas/' + $this.localGroupID + '/' + $this.localScaleID + '/turnos'

        const fullUpdate = {}

        //
        // PERCORRE OS DIAS DISPONÍVEIS NA SEMANA

        for (var i = 0; i < availableDays.length; i++)
        {
          //
          // DIA DISPONÍVEL

          var availableDay = availableDays[i].dayFmtWzero

          //
          // PERCORRE OS TURNOS DO DIA

          await Promise.all(
            weekTurns.map(async turn => {
              const isTurnValid = !!turn.plantoes === true && !!turn.plantoes[availableDay] === true

              if (isTurnValid)
              {
                //
                // APAGAR AS SEGUINTES INFORMAÇÕES DENTRO DO TURNO E DIA PERCORRIDOS AGORA:
                //
                // -> PLANTÕES
                // -> CONFIRMAÇÃO DE DISPARO
                //
                // NOTA: Confirmação de disparo era para bloquear a edição da semana (não mais)
                //

                fullUpdate[turnDutiesBasePath + '/' + turn.turnID + '/plantoes/' + availableDay + '/plantoesIDs'] = null
                fullUpdate[turnDutiesBasePath + '/' + turn.turnID + '/plantoes/' + availableDay + '/confirmedDutys'] = null

                //
                // APAGAR:
                //
                // -> PLANTÕES DO TURNO
                // -> MENSAGENS DO GRUPO QUE ESTÃO RELACIONADAS AOS PLANTÕES DO TURNO
                //

                const turnDutiesKeys = turn.plantoes[availableDay].plantoesIDs ? Object.keys(turn.plantoes[availableDay].plantoesIDs) : []

                if (turnDutiesKeys.length > 0)
                {
                  await Promise.all(
                    turnDutiesKeys.map(async turnDutyID => {
                      // PLANTÃO
                      fullUpdate['plantoes/' + turnDutyID] = null

                      // LOG DO PLANTÃO
                      fullUpdate['logs/plantoes/' + turnDutyID] = null

                      //
                      // MENSAGENS DO CHAT
                      //
                      // *** JESUS ESTÁ VIVO ***
                      // *** JESUS ESTÁ VIVO ***
                      // *** JESUS ESTÁ VIVO ***
                      //

                      const dutyChatNotifications = await apiGetGroupDutyChatMessages($this.localGroupID, turnDutyID)

                      if (dutyChatNotifications !== false) {
                        Object.keys(dutyChatNotifications).map(chatMessageKey => {
                          fullUpdate['chats/' + $this.localGroupID + '/chats/' + chatMessageKey] = null
                        })
                      }
                    })
                  )
                }
              }
            })
          )
        }

        //
        // MARCA A MENSAGEM DE NOVA SEMANA (NO CHAT) PARA SER APAGADA
        //
        // *** JESUS ESTÁ VIVO ***
        //

        const newWeekChatMessages = await apiGetGroupNewWeekChatMessages($this.localGroupID, week.firstDayOfWeek)

        // console.log('apiGetGroupNewWeekChatMessages:', $this.localGroupID, week.firstDayOfWeek, newWeekChatMessages)

        if (newWeekChatMessages !== false) {
          Object.keys(newWeekChatMessages).map(messageKey => {
            fullUpdate['chats/' + $this.localGroupID + '/chats/' + messageKey] = null
          })
        }

        //
        // NOVA MENSAGEM (+ NOTIFICAÇÃO) PARA O GRUPO:
        // -> A SEMANA FOI APAGADA
        //

        const groupName = $this.group.nome || ''
        const scaleName = $this.scaleName || ''
        const weekStart = week.value[0].dayLabel
        const weekEnd = week.value[week.value.length - 1].dayLabel

        //
        // *** JESUS ESTÁ VIVO ***
        //

        const newChatKey = apiGenerateEntityID(`chats/${$this.localGroupID}/chats`)

        fullUpdate['chats/' + $this.localGroupID + '/chats/' + newChatKey] = {
          push: {
            type: 'edit-week',
          },
          uid: authUserID,
          tipo: 'message',
          // tipo: 'new-group',
          displayName: authUser.displayName,
          mensagem: `Os plantões da semana de ${weekStart} a ${weekEnd} foram apagados do grupo ${groupName} (Escala: ${scaleName}).`,
          timestamp: apiServerTimestamp(),
          data: apiServerTimestamp(),
        }

        //
        // ATUALIZA DATA DO GRUPO

        fullUpdate['grupos/' + $this.localGroupID + '/data_atual'] = apiServerTimestamp()

        //
        // EXECUTA UPDATES

        // console.log('::: EDITAR SEMANA[fullUpdate]:', fullUpdate)

        const response = await fbFullUpdate(fullUpdate)

        // [24/01/25] console.log('EDITAR SEMANA:', response)

        this.showDialog(response.code === 0 ? 'Atenção!' : 'Sistema', '<div style="text-align: center">' + (response.code === 0 ? 'Não foi possível editar a semana. Por favor, tente novamente ou fale com nosso suporte.' : 'A semana está pronta para edição.') + '</div>', 'response', false, true, 'center')
      }

      /**
       *
       * DISPARAR SEMANA APÓS CONFLITOS
       *
       */

      if (cdResponse.cdType === 'releaseWeek')
      {
        const week = cdResponse.cdData
        this.releaseWeekDuties(week, false)
      }
    },

    /* SENHOR JESUS */
    /* DESABILITA FUNÇÃO "DUPLICAR SEMANA" QUANDO ALTERA A JORNADA */

    setJornada (jornada) {
      this.jornada = jornada

      // DESABILITA FUNÇÃO "DUPLICAR SEMANA" QUANDO ALTERA A JORNADA
      // this.weeks = this.weeks.map(week => ({ /* shouldDuplicate: false, */ value: week.value }))

      this.$store.commit('SET_WORKINGDAY', this.jornada)
    },

    async updateScaleInfo () {
      // api Update Scale Info (this.localGroupID, this.localScaleID, this.scaleName, this.scaleLocation, response => {

      await apiUpdateScaleName(this.localGroupID, this.localScaleID, this.scaleName)
      // [24/01/25] const request = await apiUpdateScaleName(this.localGroupID, this.localScaleID, this.scaleName)

      // [24/01/25] console.log('::: apiUpdateScaleName:', request)
    },

    /**
     *
     * ?
     *
     */

    removeUserFromTurn (turnID, day, turnUserID, turnUserIndex, week) {
      const dayFmt = day.dayFmt

      if (this.isWeekReleased(week)) {
        this.showDialog('Atenção!', 'A semana já foi disparada. O plantonista e o plantão serão retirados desse dia e turno. <b>Deseja continuar?</b>', 'remove-confirmed-user', { turnID, day, turnUserID, turnUserIndex, week })
      } else {
        this.showDialog('Atenção!', `Tem certeza que deseja remover o usuário do plantão do dia ${dayFmt}?`, 'remove-user', { turnID, day, turnUserID })
      }
    },

    openUserModal (turnID, selectedDate, weekID, turn)
    {
      if (
        this.$store.state.app.EditScale.jornada === 'Personalizado' && (
          Number(this.$store.state.app.EditScale.journeyWorkingDays) <= 0 ||
          Number(this.$store.state.app.EditScale.journeyWorkingDays) > 31 ||
          Number(this.$store.state.app.EditScale.journeyDaysOff) <= 0 ||
          Number(this.$store.state.app.EditScale.journeyDaysOff) > 31
        )
      ) {
        return this.showMessage('Aviso!', 'Você não terminou de personalizar a jornada!<br/ ><br />Desfaça a personalização ou informe quantos dias seguidos você quer inserir plantões (número de 1 a 31) e quantos dias de descanso.<br /><br />Depois tente incluir um novo plantão.')
      }

      this.selectedTurn = turnID
      this.selectedTurnData = turn
      this.selectedDate = selectedDate

      // console.log('::: OPEN USER MODAL:', turnID, selectedDate)

      this.$refs.userModal.open({
        scaleName: this.scaleName,
        scaleLocation: this.scaleLocation,
        scaleTurns: this.scaleTurns,
        // escala: this.localScaleID,

        groupID: this.localGroupID,
        grupoNome: this.nomeDoGrupo,

        turnID: this.selectedTurn,
        turnoDados: this.selectedTurnData,

        date: this.selectedDate,

        // [09/01/25] Solução paliativa para ler o VALOR HORA DO USUÁRIO NA ESCALA (se houver)
        scaleUsers: this.scaleUsers,
      })
    },

    /**
     *
     *
     *
     */

    async releaseWeekDuties (week, validateConflicts = true) {
      /**
       *
       * REGRAS:
       * - Se os turnos da escala não tem valor, avisa (o usuário) que os plantões serão disparados sem valor e pede para criar pelo menos um turno com valor (ou deixa zerado)
       * - Verificar se o valor do turno será usado somente nesse momento da criação dos plantões
       *
       */

      const { localGroupID } = this

      var $this = this

      const sequentialShiftConflictsInterval = !!this.group === true && !!this.group.sequentialShiftConflicts === true && Number(this.group.sequentialShiftConflictsInterval) >= 30 && Number(this.group.sequentialShiftConflictsInterval) <= 180 ? Number(this.group.sequentialShiftConflictsInterval) : false

      //
      //
      //
      // ------------------------------------------------------------------------------------------------
      // CONFLITOS (BEGIN)
      // ------------------------------------------------------------------------------------------------
      //
      //
      //

      //
      //
      // CARREGAR TODOS OS PLANTÕES DO GRUPO DENTRO DO MÊS SELECIONADO
      //
      //

      const firstWeek = this.weeks[0]
      const firstDate = firstWeek.value[0].day

      const lastWeek = this.weeks[this.weeks.length - 1]
      const lastDate = lastWeek.value[6].day

      const plantoesDoUsuario = await apiGetGroupShifts(this.$route.params.groupID, firstDate, lastDate)
      const shiftsKeys = plantoesDoUsuario ? Object.keys(plantoesDoUsuario) : []

      //
      // Filtra pelo scaleName e scaleLocation

      // const isValid = isValidDuty(shift) // && shift.groupID === this.$route.params.groupID

      const duties = shiftsKeys.length > 0 ? shiftsKeys.map(shiftID => {
        const shift = plantoesDoUsuario[shiftID]

        if (!isValidDuty(shift)) return false

        const startDateObject = ((shift.dutyStartDateTZ || '') === '+0000' ? moment.utc(shift.data_inicio) : moment(shift.data_inicio))
        const startDateMessage = startDateObject.format('DD/MM/YYYY')
        const startDate = startDateObject.format('YYYY-M-D')
        const startDateForComparison = startDateObject.format('YYYY-MM-DD')

        const startTime = valueToTime(shift.hora_inicio)

        const duration = valueToTime(shift.periodo) // valueToDB

        // [24/01/25] console.log(`endDateTime = calculateEndDateAndTime(${startDate}, ${startTime}, ${duration}, true)`)
        const endDateTime = calculateEndDateAndTime(startDate, startTime, duration, true).split(' ')

        return {
          shiftID,
          scaleID: shift.scaleID,
          ownerID: shift.uid_pegou || 0,
          duration,
          startDate,
          startDateForComparison,
          startDateMessage,
          // SENHOR JESUS está VIVO!!! - o fuso horário pode influenciar?
          startTime,
          // Calcular horário de término do plantão
          endDateWithZero: endDateTime[0],
          endTime: endDateTime[1],
        }
      }).filter(duty => !!duty === true) : []

      // [24/01/25] console.log('::: EDIT SCALE > releaseWeekDuties:', duties.length, duties)

      //
      // JESUS está VIVO !!!
      //
      // escalas com o mesmo nome pode trazer conflito na mensagem?
      //

      const conflicts = []
      // const conflictsScales = []
      // const conflictsUsers = []
      // const conflictsDates = []

      //
      //
      //
      // ------------------------------------------------------------------------------------------------
      // CONFLITOS (END)
      // ------------------------------------------------------------------------------------------------
      //
      //
      //

      //
      //
      //

      // console.log('::: sequentialShiftConflictsInterval:', sequentialShiftConflictsInterval)

      //
      //
      //

      var diasDaSemana = week.value // this.getAvailableDaysInWeek(week)

      var authUser = apiGetCurrentUser()
      var authUserID = authUser.uid

      let fullUpdate = {}

      const listaDeTurnos = this.scaleTurns

      const dutyLocal = this.scaleLocation.name

      //
      // ex: turno das 7h tem usuários em duas datas (09/07 e 21/07)

      let availableDutiesCount = 0

      /**
       *
       * Percorre os dias da semana a ser disparada
       *
       */

      for (var i = 0; i < diasDaSemana.length; i++)
      {
        const diaDaSemana = diasDaSemana[i].dayFmtWzero
        const diaDaSemanaParaComparacao = diasDaSemana[i].dayFmtYmd
        const diaDaSemanaTimestamp = diasDaSemana[i].dayTimestamp
        const diaDaSemanaParaMensagem = diasDaSemana[i].dayFmt

        //
        // Percorre todos os turnos do DIA EM PROCESSAMENTO (diasDaSemana > diaDaSemana)
        // Verifica se algum usuário foi adicionado no DIA EM PROCESSAMENTO
        // Sim? Eles serão convertidos em plantões
        //

        // APENAS TURNOS (COM PLANTÕES) NO DIA EM PROCESSAMENTO

        listaDeTurnos.forEach(turn => {
          const diaComUsuarios = !!turn.plantoes === true && !!turn.plantoes[diaDaSemana] === true ? turn.plantoes[diaDaSemana] : false

          // let newDuty

          const turnPlantoesPath = `escalas/${$this.localGroupID}/${$this.localScaleID}/turnos/${turn.turnID}/plantoes/${diaDaSemana}`

          //
          // CONFIRM IF THIS DAY CAN BE FIRED
          //

          const turnosDoDia = diaComUsuarios.confirmedDutys !== true && !!diaComUsuarios.users === true && typeof diaComUsuarios.users === 'object' ? Object.entries(diaComUsuarios.users) : []

          if (turnosDoDia.length > 0)
          {
            const turnoHoraInicio = formatDbTime(turn.hour)
            const turnoDuracao = valueToDB(turn.duration)
            const turnoNome = turn.name || ''
            const turnValue = turn.value || 0

            const turnDurationHHMM = formatDbTime(turn.duration)

            //
            // PROCESS EDIT SCALE USER SHIFTS
            //

            turnosDoDia.map(([_, turnDayDuty]) => {
              //
              //
              //

              const isUserDuty = !!turnDayDuty.availableTurn === false && !!turnDayDuty.uid === true

              //
              // Editar puxar o valor do usuário quando o turno é valor ZERO
              //

              let dutyValue = turnValue

              if (isUserDuty && !!dutyValue === false)
              {
                // Valor do usuário na escala (Se houver)
                const userScaleHourlyRate = !!this.scaleUsers === true && !!this.scaleUsers[turnDayDuty.uid] === true && !!this.scaleUsers[turnDayDuty.uid].hourlyrate === true ? this.scaleUsers[turnDayDuty.uid].hourlyrate : 0

                if (userScaleHourlyRate >= 1.00)
                {
                  // Duração do plantão em minutos
                  const totalMinutes = durationToMinutes(turnDurationHHMM) // Ex: 2 horas e 30 minutos = 150 minutos
                  // Calcula o novo valor do plantão com base na duração e no valor por hora
                  const newDutyValue = (totalMinutes / 60) * userScaleHourlyRate // Valor proporcional
                  // Formata o valor com duas casas decimais
                  dutyValue = parseFloat(newDutyValue.toFixed(2))
                }
              }

              //
              //
              //

              // const turnoStartDateTime = (new Date(`${diaDaSemana}T${turnoHoraInicio}:00.000Z`)).getTime()

              // console.log(`turnoEndDateTime = calculateEndDateAndTime(${diaDaSemana}, ${turnoHoraInicio}, ${turnDurationHHMM}, true)`)
              // const turnoEndDateTime = calculateEndDateAndTime(diaDaSemana, turnoHoraInicio, turnDurationHHMM, true).split(' ')
              // turnoEndDateTime = (new Date(`${turnoEndDateTime[0]}T${turnoEndDateTime[1]}:00.000Z`)).getTime() // 2024-02-01T00:30:00.000Z

              //
              // Insere plantão disponível ou para usuário específico
              //

              if (!!turnDayDuty.closedTurn === false)
              {
                //
                // ------------------------------------------------------------------------------------------------
                // CONFLITOS (BEGIN)
                // ------------------------------------------------------------------------------------------------

                //
                // Jesus VIVE!!!
                //
                // Escala nova é encontrada? Testar uma escala criada por outro gestor entre ENTRAR NA TELA e O DISPARO
                //

                // TEM ALGUM PLANTÃO DISPARADO EM CONFLITO PARA ESSE USUÁRIO, DATA E TURNO EM PROCESSAMENTO NO "EDIT SCALE" ?

                if (isUserDuty)
                {
                  duties.forEach(shift => {
                    if (shift.ownerID === turnDayDuty.uid)
                    {
                      if (
                        checkConflict(
                          { startDate: shift.startDateForComparison, startTime: shift.startTime, duration: shift.duration },
                          { startDate: diaDaSemanaParaComparacao, startTime: turnoHoraInicio, duration: turnDurationHHMM },
                          sequentialShiftConflictsInterval,
                          // turnDayDuty.nome || 'Unknown'
                        )
                      )
                      {
                        const scaleFound = this.listeners.groupScales.find(scale => scale.scaleID === shift.scaleID)
                        const scaleName = !!scaleFound && !!scaleFound.scaleName ? scaleFound.scaleName : shift.scaleID

                        conflicts.push({
                          scaleID: shift.scaleID,
                          scaleName,

                          userID: turnDayDuty.uid,
                          userName: turnDayDuty.nome,

                          turnDate: diaDaSemanaParaMensagem,
                          turnTime: turnoHoraInicio,
                          turnDuration: turnDurationHHMM,

                          shiftDate: shift.startDateMessage,
                          shiftTime: shift.startTime,
                          shiftDuration: shift.duration,
                        })

                        // if (!conflictedScale) conflictsScales.push({ scaleID: existentEditScaleUserShifts.scaleID, scaleName })
                        // if (!conflictedUser) conflictsUsers.push({ scaleID: existentEditScaleUserShifts.scaleID, userID: turnDayDuty.uid, userName: turnDayDuty.nome })
                        // if (!conflictedDate) conflictsDates.push({ scaleID: existentEditScaleUserShifts.scaleID, userID: turnDayDuty.uid, date: diaDaSemanaParaMensagem })
                      }
                    }
                  })
                }

                /* if (existentEditScaleUserShifts.length > 0)
                {
                  const scaleFound = this.listeners.groupScales.find(scale => scale.scaleID === existentEditScaleUserShifts.scaleID)
                  const scaleName = !!scaleFound && !!scaleFound.scaleName ? scaleFound.scaleName : existentEditScaleUserShifts.scaleID

                  const conflictedScale = conflictsScales.some(conflictScale => !!conflictScale.scaleID === true && conflictScale.scaleID === existentEditScaleUserShifts.scaleID)
                  const conflictedUser = conflictsUsers.some(conflictUser => !!conflictUser.scaleID === true && !!conflictUser.userID === true && conflictUser.scaleID === existentEditScaleUserShifts.scaleID && conflictUser.userID === turnDayDuty.uid)
                  const conflictedDate = conflictsDates.some(conflictDate => !!conflictDate.scaleID === true && !!conflictDate.userID === true && !!conflictDate.date === true && conflictDate.scaleID === existentEditScaleUserShifts.scaleID && conflictDate.userID === turnDayDuty.uid && conflictDate.date === diaDaSemanaParaMensagem)

                  if (!conflictedScale) conflictsScales.push({ scaleID: existentEditScaleUserShifts.scaleID, scaleName })
                  if (!conflictedUser) conflictsUsers.push({ scaleID: existentEditScaleUserShifts.scaleID, userID: turnDayDuty.uid, userName: turnDayDuty.nome })
                  if (!conflictedDate) conflictsDates.push({ scaleID: existentEditScaleUserShifts.scaleID, userID: turnDayDuty.uid, date: diaDaSemanaParaMensagem })
                } */

                // ------------------------------------------------------------------------------------------------
                // CONFLITOS (END)
                // ------------------------------------------------------------------------------------------------
                //

                //
                // CRIA A ESTRUTURA DE DADOS DO PLANTÃO
                //

                const dutyData = createDutyObject({
                  dutyGroupID: localGroupID,
                  dutyScaleID: $this.localScaleID,
                  dutyCreatorID: authUserID,
                  dutyOwnerID: turnDayDuty.uid || 0,
                  dutyMessageDate: diaDaSemanaParaMensagem,
                  dataInicioFmt: diaDaSemana,
                  dutyStartDate: diaDaSemanaTimestamp,
                  dutyStartTime: turnoHoraInicio,
                  dutyDuration: turnoDuracao,
                  shiftName: turnoNome,
                  dutyName: $this.scaleName,
                  dutyLocal,
                  dutyValue,

                  // Se o plantão é do tipo DISPONÍVEL, não precisa notificar no chat e via push
                  preventAvailableDutyNotification: isUserDuty === false,

                  isUserDuty,
                  updateGroup: false,
                  turnPath: turnPlantoesPath,
                })

                if (!isUserDuty) {
                  // newDuty.notify = 'no'
                  availableDutiesCount++
                }

                fullUpdate = {
                  ...fullUpdate,
                  ...dutyData,
                }
              }
            })
          }

          //
          // Atualiza o status do plantão dentro do turno, confirmando o disparo e bloqueando para edições
          //

          fullUpdate[turnPlantoesPath + '/confirmedDutys'] = true
        })
      }

      /**
       *
       * O SISTEMA VAI AVISAR O GRUPO QUE A SEMANA DISPARADA TEM PLANTÕES DISPONÍVEIS
       *
       */

      //
      // NOVA MENSAGEM (+ NOTIFICAÇÃO) PARA O GRUPO:
      // -> A SEMANA DISPARADA TEM PLANTÕES DISPONÍVEIS
      //

      if (availableDutiesCount > 0)
      {
        //
        // *** JESUS ESTÁ VIVO ***
        //

        const newChatKeyAvailables = apiGenerateEntityID(`chats/${$this.localGroupID}/chats`)

        const availableDutiesPhrase = availableDutiesCount === 1 ? '1 plantão disponível' : `${availableDutiesCount} plantões disponíveis`

        const groupName = $this.group.nome || ''
        const scaleName = $this.scaleName || ''
        const weekStart = week.value[0].dayLabel
        const weekEnd = week.value[week.value.length - 1].dayLabel

        fullUpdate['chats/' + $this.localGroupID + '/chats/' + newChatKeyAvailables] = {
          referer: week.firstDayOfWeek,

          push: {
            type: 'new-duty',
          },
          uid: authUserID,
          tipo: 'message',
          // tipo: 'new-group',
          displayName: authUser.displayName,
          mensagem: `Tem ${availableDutiesPhrase} na semana de ${weekStart} a ${weekEnd} no grupo ${groupName} (Escala: ${scaleName}).`,
          timestamp: apiServerTimestamp(),
          data: apiServerTimestamp(),
        }
      }

      //
      //
      //
      // ------------------------------------------------------------------------------------------------
      // CONFLITOS (BEGIN)
      // ------------------------------------------------------------------------------------------------
      //
      //
      //

      // ATUALIZA O TIMESTAMP DO GRUPO PARA PROVOCAR UM RECARREGAMENTO DOS DADOS
      fullUpdate['grupos/' + localGroupID + '/data_atual'] = apiServerTimestamp()

      //
      //
      // Mostra conflitos caso algum usuário tenha outro plantão no mesmo horário
      //
      //

      if (validateConflicts && conflicts.length > 0)
      {
        let conflictsTableHtml = '<table class="tableConflicts">'
        conflictsTableHtml += '<tr><th>Membro</th><th>Turno</th><th>Plantão em conflito</th><th>Escala do conflito</th></tr>'

        conflicts.forEach(user => {
          conflictsTableHtml += '<tr style="font-size: 12px">'
          conflictsTableHtml += `<td>${user.userName}</td>`
          conflictsTableHtml += `<td>${user.turnDate} ${user.turnTime} (${user.turnDuration})</td>`
          conflictsTableHtml += `<td>${user.shiftDate} ${user.shiftTime} (${user.shiftDuration})</td>`
          conflictsTableHtml += `<td>${user.scaleName}</td>`
          conflictsTableHtml += '</tr>'
        })

        /* conflictsScales.forEach(scale => {
          conflictsUsers.forEach(user => {
            if (scale.scaleID === user.scaleID) {
              conflictsTableHtml += `<tr><td><b style="color: indianred">${scale.scaleName}</b></td>`
              conflictsTableHtml += `<td><b style="color: indianred">${user.userName}</b></td><td>`

              conflictsDates.forEach(date => {
                if (date.scaleID === scale.scaleID && date.userID === user.userID) {
                  conflictsTableHtml += `${date.date}<br />`
                }
              })

              conflictsTableHtml += '</td>'
            }

            conflictsTableHtml += '</tr>'
          })
        }) */

        conflictsTableHtml += '</table>'

        //
        //
        //

        // const text = `<div style="text-align: center">Algum usuário já tem um plantão no mesmo dia e horário.<br /><br />Veja os conflitos abaixo:<br /><br />${conflictsTableHtml}<br /><b>Deseja disparar a semana mesmo assim?</b></div>`
        const text = `<div style="text-align: center">Algum plantão que você quer disparar está em conflito com outro plantão existente:<br /><br />${conflictsTableHtml}<br /><b>Deseja disparar a semana mesmo assim?</b></div>`

        this.showConfirmBox({
          title: 'Conflito!',
          text,
          type: 'releaseWeek',
          data: week,
          isResponse: false,
          buttonPosition: 'center',
          width: 900, // 768, // 480,
          closeText: 'Não',
          continueText: 'Sim',
        })

        return false
      }

      //
      //
      //
      // EXECUTA AS INSERÇÕES NO BANCO
      //
      //
      //

      // [24/01/25] console.log(`::: DISPARAR SEMANA[${week.firstDayOfWeek}]:`, fullUpdate)

      const response = await fbFullUpdate(fullUpdate)

      if (response.code === 0) {
        this.showMessage('Atenção!', '<div style="text-align: center">Não foi possível criar plantões. Por favor, tente novamente ou fale com nosso suporte.</div>')
      } else {
        this.showMessage('Sistema', '<div style="text-align: center">Os plantões foram criados com sucesso!</div>')
      }
    },

    /**
     *
     * ?
     *
     */

    getDutyImage (scaleUser, day) {
      if (scaleUser && scaleUser.userName && !scaleUser.availableTurn) {
        var userFound = (scaleUser.userID && this.groupUsers) ? this.groupUsers.filter(user => {
          return user.userID === scaleUser.userID
        }) : false

        const userPicture = (!!userFound === true && !!userFound[0] === true && !!userFound[0].userImage === true) ? userFound[0].userImage : '/images/user-profile-broken.png' // userProfileBroken

        return userPicture
      } else if (scaleUser.availableTurn && !scaleUser.closedTurn) {
        return /* this.isExpiredDay(day) */ day.isExpired ? '/images/duty-status-cancelado.png' : '/images/duty-status-available.png'
      } else {
        return '/images/duty-status-cancelado.png'
      }
    },

    /**
     *
     * ?
     *
     */

    getTurnsByDay (day, period)
    {
      if (!day || !day.day || this.scaleTurns.length === 0) return []

      const { dayOfWeek, dayFmtWzero: date } = day

      const turnsByDay = this.scaleTurns.map(turn => {
        // console.log('turn:', turn)
        const dayTurn = (period === 'morning' && turn.turnStartTime < 17) || (period === 'night' && turn.turnStartTime >= 17)
        if (!dayTurn) return false

        // 0 (dom), 1 (seg), 2, 3, 4, 5 e 6
        const mondayStartedDays = this.startOnMonday === 'yes' ? turn.days.map(t => (t === 0) ? 6 : (t - 1)) : turn.days
        const hasDay = mondayStartedDays.filter(d => d === dayOfWeek)

        if (hasDay.length === 0) return false

        // return hasDay.length > 0 ? turn : false

        const dateHaveShifts = !!turn === true && !!turn.plantoes === true && !!turn.plantoes[date] === true && !!turn.plantoes[date].users === true
        const turnUserKeys = dateHaveShifts ? Object.keys(turn.plantoes[date].users) : []
        const users = turnUserKeys.length > 0 ? turnUserKeys.map(turnUserID => {
          const user = turn.plantoes[date].users[turnUserID]

          if (!!user === false) return false

          const userID = user.uid
          const userName = !!user.nome === true ? String(user.nome).trim() : ''
          const userImageIsValid = user.img && typeof user.img === 'string' && user.img.indexOf('https://firebasestorage.googleapis.com/') !== -1
          const userImage = userImageIsValid ? user.img : userProfileBroken

          return { ...user, turnUserID, userID, userImage, userImageIsValid, userName }
        }).filter(turnUser => !!turnUser === true) : []

        return { ...turn, turnHour: valueToTime(turn.hour), turnDuration: formatFloatToScaleDuration(turn.duration), users }
      }).filter(turnByDay => !!turnByDay === true)

      if (turnsByDay.length > 0) turnsByDay.sort((a, b) => a.turnStartTime - b.turnStartTime)

      // console.log(`[${date}] [${period}] GET TURNS BY DAY:`, dayOfWeek, turnsByDay)

      return turnsByDay
    },

    isDayOutOfScale (day, actualMonth) {
    },

    /**
     *
     * CHECK IF THIS WEEK WAS RELEASED
     *
     */

    isWeekReleased (week) {
      if (this.scaleTurns.length === 0) return false

      return week.value.some(day => {
        return this.scaleTurns.some(turn => {
          return turn.plantoes && turn.plantoes[day.dayFmtWzero] && turn.plantoes[day.dayFmtWzero].confirmedDutys
        })
      })
    },

    /**
     *
     * CHECK IF THIS WEEK HAS DUTIES
     *
     */

    weekHasScale (week) {
      if (this.scaleTurns.length === 0) return false

      const has = week.value.some(day => {
        const weekDay = day.dayFmtWzero
        const innerBool = this.scaleTurns.some(turn => turn.plantoes && turn.plantoes[weekDay])
        return innerBool
      })

      return has
    },

    /**
     *
     *
     *
     */

    getNextFreeWeek (week) {
      var $this = this

      if (this.scaleTurns.length === 0) {
        return false
      }

      let areAnyDayInNextWeek = false
      let numberWeeksAhead = 0
      let nextFreeWeekSundayObj
      let nextFreeWeekMondayObj
      let nextFreeWeekTuesdayObj
      let nextFreeWeekWednesdayObj
      let nextFreeWeekThursdayObj
      let nextFreeWeekFridayObj
      let nextFreeWeekSaturdayObj

      do {
        // próxima semana
        numberWeeksAhead++

        // dias da próxima semana
        nextFreeWeekSundayObj = week.value[0].day.clone().add((7 * numberWeeksAhead), 'days')
        nextFreeWeekMondayObj = week.value[1].day.clone().add((7 * numberWeeksAhead), 'days')
        nextFreeWeekTuesdayObj = week.value[2].day.clone().add((7 * numberWeeksAhead), 'days')
        nextFreeWeekWednesdayObj = week.value[3].day.clone().add((7 * numberWeeksAhead), 'days')
        nextFreeWeekThursdayObj = week.value[4].day.clone().add((7 * numberWeeksAhead), 'days')
        nextFreeWeekFridayObj = week.value[5].day.clone().add((7 * numberWeeksAhead), 'days')
        nextFreeWeekSaturdayObj = week.value[6].day.clone().add((7 * numberWeeksAhead), 'days')

        var nextFreeWeekSunday = nextFreeWeekSundayObj.format('YYYY-M-D')
        var nextFreeWeekMonday = nextFreeWeekMondayObj.format('YYYY-M-D')
        var nextFreeWeekTuesday = nextFreeWeekTuesdayObj.format('YYYY-M-D')
        var nextFreeWeekWednesday = nextFreeWeekWednesdayObj.format('YYYY-M-D')
        var nextFreeWeekThursday = nextFreeWeekThursdayObj.format('YYYY-M-D')
        var nextFreeWeekFriday = nextFreeWeekFridayObj.format('YYYY-M-D')
        var nextFreeWeekSaturday = nextFreeWeekSaturdayObj.format('YYYY-M-D')

        // verifica se tem escala montada em algum dia da semana processada
        areAnyDayInNextWeek = $this.scaleTurns.some(turn => {
          // return turn.plantoes && turn.plantoes[formattedSundayOfNextFreeWeek]
          return turn.plantoes && (
            (turn.plantoes[nextFreeWeekSunday] && turn.plantoes[nextFreeWeekSunday].users) ||
            (turn.plantoes[nextFreeWeekMonday] && turn.plantoes[nextFreeWeekMonday].users) ||
            (turn.plantoes[nextFreeWeekTuesday] && turn.plantoes[nextFreeWeekTuesday].users) ||
            (turn.plantoes[nextFreeWeekWednesday] && turn.plantoes[nextFreeWeekWednesday].users) ||
            (turn.plantoes[nextFreeWeekThursday] && turn.plantoes[nextFreeWeekThursday].users) ||
            (turn.plantoes[nextFreeWeekFriday] && turn.plantoes[nextFreeWeekFriday].users) ||
            (turn.plantoes[nextFreeWeekSaturday] && turn.plantoes[nextFreeWeekSaturday].users)
          )
        })
      } while (areAnyDayInNextWeek === true)

      return {
        numberWeeksAhead,
        0: nextFreeWeekSundayObj.format('DD/MM/YYYY'),
        1: nextFreeWeekMondayObj.format('DD/MM/YYYY'),
        2: nextFreeWeekTuesdayObj.format('DD/MM/YYYY'),
        3: nextFreeWeekWednesdayObj.format('DD/MM/YYYY'),
        4: nextFreeWeekThursdayObj.format('DD/MM/YYYY'),
        5: nextFreeWeekFridayObj.format('DD/MM/YYYY'),
        6: nextFreeWeekSaturdayObj.format('DD/MM/YYYY'),
      }
    },

    buildDuplicatedWeek (week, numberWeeksAhead) {
      var $this = this
      let weekOrDayAlreadySet = false
      const update = {}

      week.value.map(date => {
        var formattedDay = date.dayFmtWzero
        var dateOfNextWeek = date.day.clone().add((7 * numberWeeksAhead), 'days')
        // var dateOfNextWeek = this.$moment(date.day).add((7 * numberWeeksAhead), 'days')
        var formattedDayOfNextWeek = dateOfNextWeek.format('YYYY-M-D')

        if ($this.scaleTurns.length > 0) {
          $this.scaleTurns.forEach(turn => {
            if (!weekOrDayAlreadySet) {
              if (turn.plantoes) {
                if (turn.plantoes[formattedDayOfNextWeek] && turn.plantoes[formattedDayOfNextWeek].users) {
                  weekOrDayAlreadySet = true
                } else if (turn.plantoes[formattedDay]) {
                  const plantao = turn.plantoes[formattedDay]
                  const turnUsers = plantao.users || false
                  const turnUsersKeys = turnUsers ? Object.keys(plantao.users) : []

                  // if (plantao.users) {

                  if (turnUsersKeys.length > 0) {
                    turnUsersKeys.forEach(userKey => {
                      const key = apiGenerateEntityID(`escalas/${$this.localGroupID}/${$this.localScaleID}/turnos/${turn.turnID}/plantoes/${formattedDayOfNextWeek}/users`)

                      update['escalas/' + $this.localGroupID + '/' + $this.localScaleID + '/turnos/' + turn.turnID + '/plantoes/' + formattedDayOfNextWeek + '/users/' + key] = turnUsers[userKey]
                    })
                  }
                }
              }
            }
          })
        }
      })

      if (weekOrDayAlreadySet) {
        return {
          code: 0,
          response: 'conflict',
        }
      } else if (Object.keys(update).length === 0) {
        return {
          code: 0,
          response: 'empty',
        }
      }

      return {
        code: 1,
        response: update,
      }
    },
  },
}
